import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Instagram, X } from "lucide-react";
import { INSTAGRAM_URL } from "./data";

const IG_GRADIENT =
  "linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)";

const InstagramPopup = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 6000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setDismissed(true);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && !dismissed && (
        <motion.div
          data-testid="instagram-popup"
          initial={{ opacity: 0, y: 40, rotate: -2 }}
          animate={{ opacity: 1, y: 0, rotate: -2 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-20 right-4 z-[60] w-[calc(100vw-2rem)] max-w-xs border-2 border-ink bg-paper p-5 shadow-hard md:bottom-6 md:right-6"
        >
          <button
            onClick={close}
            data-testid="instagram-popup-close"
            aria-label="Close Instagram popup"
            className="absolute -right-2 -top-2 flex h-8 w-8 items-center justify-center border-2 border-ink bg-paper transition-colors hover:bg-polered hover:text-paper"
          >
            <X size={14} />
          </button>
          <div className="flex items-center gap-3">
            <span
              className="flex h-11 w-11 shrink-0 items-center justify-center border-2 border-ink"
              style={{ background: IG_GRADIENT }}
            >
              <Instagram size={22} className="text-white" />
            </span>
            <p className="font-display text-xl uppercase leading-none">
              Follow us on Instagram
            </p>
          </div>
          <p className="mt-3 font-hand text-lg text-ink/70">
            @oliversbarbershop — fresh cuts in your feed
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-popup-follow"
            onClick={close}
            className="mt-4 flex items-center justify-center gap-2 border-2 border-ink px-4 py-3 font-display text-lg uppercase text-white"
            style={{ background: IG_GRADIENT }}
          >
            <Instagram size={18} /> Follow
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InstagramPopup;
